import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { selectPRLoader } from 'src/store/selectors/PropertyLoader';
import NotesWithState from 'src/components/NotesNewWithState/NotesWithState';
import Loader from 'src/components/Loader';
import {
  SuiteNotesProvider,
  useSuiteNotesActionsFromContext,
  useSuiteNotesDataFromContext,
} from 'src/pages/Suite/SuiteNotes/SuiteNotesContext/SuiteNotesContext';

const SuiteNotesInner = ({
  suite,
  onFetchSuiteData,
  fetchUpdatedSuiteCounts,
}: any) => {
  const loader = useSelector(selectPRLoader);

  const { notes, loadingNotesDocs } = useSuiteNotesDataFromContext();

  const { fetchNotes, saveNote, updateNote, deleteNote, clearSearch } =
    useSuiteNotesActionsFromContext();

  useEffect(() => {
    clearSearch();
    fetchNotes(suite.id);
  }, [suite.id]);

  const handleSaveNote = async (note: any) => {
    await saveNote(note, suite.id);
    await onFetchSuiteData();
  };

  const handleUpdateNote = async (note: any) => {
    await updateNote(note, suite.id);
    await onFetchSuiteData();
  };

  const handleDeleteNote = async (noteToDelete: any) => {
    await deleteNote(noteToDelete, suite.id);
    await onFetchSuiteData();
  };

  return loader || loadingNotesDocs ? (
    <Loader />
  ) : (
    <NotesWithState
      notes={notes}
      onSaveNote={handleSaveNote}
      onDeleteNote={handleDeleteNote}
      onEditNote={handleUpdateNote}
      breadcrumb={suite.number}
      from="suites"
    />
  );
};

const SuiteNotes = ({ suite, onFetchSuiteData }: any) => {
  return (
    <SuiteNotesProvider>
      <SuiteNotesInner suite={suite} onFetchSuiteData={onFetchSuiteData} />
    </SuiteNotesProvider>
  );
};

export default SuiteNotes;
